import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as jointUse from '../joint-use'

// TODO: We already have "when" property on snapshot.
// This is a workaround for bug when we pass period in DMS query and it is complaining because snapshot doesn't have active periods attribute.
export const RESOURCE = {
  payload: {
    canBeOptional: false,
    context: core.dms.models.Attribute.Id.Context.from({
      context: jointUse.RESOURCE.payload.dimension.partialId,
      partialId: jointUse.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Snapshot,
    }),
    default: '{(,)}',
    description: 'Space survey active periods',
    isOptional: false,
    name: 'Active Period(s)',
    partialId: PartialId.Standard.create('active_periods'),
    type: core.common.value.types.Intrinsic.DateMultirange,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
